<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  reportName="CostCenter"
  [erroremessage]="erroremessage"
  pathPreFix="HRM"
  [defaultHeight]="25"
  (valueChangeByApiName)="onvalueChangeByApiName($event)"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="HRNotificationDetails && HRNotificationDetails.length > 0">
    <ssg-tabset (tabChange)="selectTab($event)" class="tabcontainer tabcontentbox">
      <ssg-tab tabTitle="شرح حکم">
        <ssg-textarea
          id="Description"
          name="Description"
          [group]="formGroup"
          label="شرح حکم"
          required="false"
          disabled="false"
          maxLength="1000"
          class="info">
        </ssg-textarea>
      </ssg-tab>
      <ssg-tab tabTitle="سازمان بیمه و دارایی">
        <editable-grid
          #defaultUnit
          *ngIf="isActveTab('سازمان بیمه و دارایی') && model.HrmPersonnelCompanyAssigns && model.HrmPersonnelCompanyAssigns.length > 0"
          [columns]="HrmPersonnelCompanyAssigns"
          [dataList]="model.HrmPersonnelCompanyAssigns"
          [isAdd]="false"
          [customDataList]="onRowSelected"
          (valueChanges)="valueChanges($event)"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="عوامل حقوقی">
        <editable-grid
          *ngIf="isActveTab('عوامل حقوقی') && model.HRNotificationDetails && model.HRNotificationDetails.length > 0"
          [columns]="HRNotificationDetails"
          [dataList]="model.HRNotificationDetails"
          [isAdd]="false"
          (valueChanges)="valueChanges($event)"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
      <ssg-tab tabTitle="سطوح حسابها">
        <form-control-model [defaultHeight]="25" [columns]="DetaileLedgerColumns" height="65" [group]="formGroup" [model]="model">
        </form-control-model>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
